<template>
  <activity-loading
    :percentValue="percentLoaded"
    :text-title="data.loading"
    bg-color-activity="navy-blue-200"
    bg-color-progress="navy-blue-100"
    bg-color-progress-bar="green-100"
    next-component="IntroPage"
    text-color-loading-title="white"
    :enable-bumper="isBumperEnabled"
  >
    <template v-slot:logo> </template>
  </activity-loading>
</template>

<script>
import { computed } from '@vue/composition-api';
import { ActivityLoading } from '@discoveryeducation/components';

export default {
  name: 'LoadingPage',
  components: { ActivityLoading },
  setup() {
    const isBumperEnabled = computed(() => {
      return process.env.VUE_APP_ENABLE_BUMPER === 'TRUE';
    });

    return { isBumperEnabled };
  },
};
</script>

<style lang="stylus" scoped>

::v-deep
  .activity-loading
    background-image url('~@/assets/images/bg-loading.gif')

    .activity-loading__title
      text-transform uppercase
      padding 1.7em 0 0.3em 0
      font-size 21px
      font-family Nunito-Bold
</style>
